import React from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { FloatingCTA } from '../components/FloatingCTA';
import { BellIcon, BellRingIcon, FilterIcon, MailIcon, MessageSquareIcon, SmartphoneIcon, ZapIcon, CheckIcon, ChevronRightIcon, ChevronDownIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function AlertesIntelligentesPage() {
  return <div className="min-h-screen bg-white text-gray-900 font-sans" data-id="element-959">
      <Navbar data-id="element-960" />
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-blue-50 to-white relative overflow-hidden" data-id="element-961">
        <div className="container mx-auto px-4 relative z-10" data-id="element-962">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-963">
            <div className="lg:w-1/2" data-id="element-964">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5
            }} data-id="element-965">
                <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-966">
                  Fonctionnalité
                </span>
                <h1 className="text-4xl md:text-5xl font-bold text-blue-900 mb-6" data-id="element-967">
                  Alertes intelligentes personnalisées
                </h1>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-968">
                  Ne manquez plus aucune opportunité d'affaires grâce à notre
                  système d'alertes intelligentes. Recevez des notifications en
                  temps réel pour les appels d'offres qui correspondent
                  parfaitement à votre profil.
                </p>
                <div className="flex flex-wrap gap-4" data-id="element-969">
                  <Button variant="primary" size="lg" className="shadow-lg shadow-blue-500/20" data-id="element-970">
                    Essayer gratuitement
                  </Button>
                  <Button variant="outline" size="lg" className="border-2 border-blue-900" data-id="element-971">
                    Voir la démo
                  </Button>
                </div>
              </motion.div>
            </div>
            <div className="lg:w-1/2" data-id="element-972">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="relative" data-id="element-973">
                <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-600 to-yellow-500 rounded-2xl blur opacity-20" data-id="element-974"></div>
                <div className="bg-white p-6 rounded-2xl shadow-xl border border-gray-100 relative" data-id="element-975">
                  <div className="flex items-center mb-4" data-id="element-976">
                    <div className="h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-3" data-id="element-977">
                      <BellRingIcon size={20} data-id="element-978" />
                    </div>
                    <div data-id="element-979">
                      <h3 className="font-semibold text-gray-900" data-id="element-980">
                        Nouvelle alerte
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-981">
                        Appel d'offres correspondant à votre profil
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4 mb-4" data-id="element-982">
                    <h4 className="font-medium text-blue-800 mb-2" data-id="element-983">
                      Construction d'un centre commercial à Tunis
                    </h4>
                    <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-984">
                      <span className="bg-green-100 text-green-800 text-xs px-2 py-0.5 rounded-full mr-2" data-id="element-985">
                        Correspondance: 92%
                      </span>
                      <span data-id="element-986">Expire dans 5 jours</span>
                    </div>
                    <p className="text-sm text-gray-600 mb-3" data-id="element-987">
                      Ce projet correspond à votre expertise en construction
                      commerciale et à votre zone géographique préférée.
                    </p>
                    <div className="flex justify-end" data-id="element-988">
                      <Button variant="primary" size="sm" data-id="element-989">
                        Voir les détails
                      </Button>
                    </div>
                  </div>
                  <div className="flex justify-between items-center text-sm" data-id="element-990">
                    <span className="text-gray-500" data-id="element-991">
                      Reçue il y a 23 minutes
                    </span>
                    <a href="#" className="text-blue-600 font-medium" data-id="element-992">
                      Gérer mes alertes
                    </a>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-gradient-radial from-yellow-100 to-transparent opacity-70" data-id="element-993"></div>
        <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-radial from-blue-50 to-transparent opacity-70" data-id="element-994"></div>
      </section>
      {/* Features Section */}
      <section className="py-20" data-id="element-995">
        <div className="container mx-auto px-4" data-id="element-996">
          <div className="text-center mb-16" data-id="element-997">
            <span className="inline-block px-3 py-1 bg-blue-50 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-998">
              Caractéristiques
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-999">
              Comment fonctionnent nos alertes intelligentes
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1000">
              Notre système d'intelligence artificielle analyse en continu les
              appels d'offres publiés pour vous proposer uniquement les
              opportunités les plus pertinentes.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1001">
            {[{
            icon: <FilterIcon size={32} data-id="element-1002" />,
            title: 'Filtrage intelligent',
            description: "Définissez vos critères de recherche une seule fois et laissez notre système filtrer automatiquement les appels d'offres pertinents."
          }, {
            icon: <ZapIcon size={32} data-id="element-1003" />,
            title: 'Notifications en temps réel',
            description: "Soyez informé immédiatement dès qu'un nouvel appel d'offres correspondant à votre profil est publié."
          }, {
            icon: <BellIcon size={32} data-id="element-1004" />,
            title: 'Alertes multi-canaux',
            description: 'Recevez vos alertes par email, SMS, ou directement sur la plateforme selon vos préférences.'
          }].map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-1005">
                <div className="w-14 h-14 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mb-5" data-id="element-1006">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1007">
                  {feature.title}
                </h3>
                <p className="text-gray-600" data-id="element-1008">{feature.description}</p>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* Notification Channels */}
      <section className="py-20 bg-gray-50" data-id="element-1009">
        <div className="container mx-auto px-4" data-id="element-1010">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-1011">
            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5
          }} viewport={{
            once: true
          }} data-id="element-1012">
              <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-1013">
                Multi-canaux
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6" data-id="element-1014">
                Choisissez comment recevoir vos alertes
              </h2>
              <p className="text-lg text-gray-600 mb-8" data-id="element-1015">
                Configurez vos préférences de notification pour recevoir vos
                alertes via le canal qui vous convient le mieux.
              </p>
              <div className="space-y-5" data-id="element-1016">
                {[{
                icon: <MailIcon size={24} data-id="element-1017" />,
                title: 'Alertes par email',
                description: "Recevez des emails détaillés avec toutes les informations sur les nouveaux appels d'offres."
              }, {
                icon: <SmartphoneIcon size={24} data-id="element-1018" />,
                title: 'Notifications SMS',
                description: 'Soyez alerté instantanément sur votre téléphone pour les opportunités urgentes.'
              }, {
                icon: <MessageSquareIcon size={24} data-id="element-1019" />,
                title: "Notifications dans l'application",
                description: 'Consultez toutes vos alertes directement depuis votre tableau de bord.'
              }].map((channel, index) => <div key={index} className="flex items-start" data-id="element-1020">
                    <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1021">
                      {channel.icon}
                    </div>
                    <div data-id="element-1022">
                      <h3 className="font-bold text-gray-900 mb-1" data-id="element-1023">
                        {channel.title}
                      </h3>
                      <p className="text-gray-600" data-id="element-1024">{channel.description}</p>
                    </div>
                  </div>)}
              </div>
            </motion.div>
            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5
          }} viewport={{
            once: true
          }} data-id="element-1025">
              <div className="bg-white p-6 rounded-xl shadow-xl border border-gray-200" data-id="element-1026">
                <h3 className="text-xl font-bold text-gray-900 mb-5" data-id="element-1027">
                  Configuration des alertes
                </h3>
                <div className="space-y-5" data-id="element-1028">
                  {/* Secteurs et sous-secteurs */}
                  <div data-id="element-1029">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1030">
                      Secteurs et sous-secteurs d'activité
                    </label>
                    <div className="border border-gray-300 rounded-md overflow-hidden" data-id="element-1031">
                      {/* Secteur 1 avec sous-secteurs */}
                      <div className="border-b border-gray-200" data-id="element-1032">
                        <div className="flex items-center justify-between px-3 py-2 bg-gray-50 cursor-pointer" data-id="element-1033">
                          <div className="flex items-center" data-id="element-1034">
                            <input type="checkbox" id="secteur-btp" className="h-4 w-4 text-blue-600 rounded" defaultChecked data-id="element-1035" />
                            <label htmlFor="secteur-btp" className="ml-2 text-gray-700 font-medium" data-id="element-1036">
                              BTP & Construction
                            </label>
                          </div>
                          <ChevronDownIcon size={16} className="text-gray-500" data-id="element-1037" />
                        </div>
                        <div className="px-3 py-2 bg-white" data-id="element-1038">
                          <div className="grid grid-cols-2 gap-2 pl-6" data-id="element-1039">
                            <div className="flex items-center" data-id="element-1040">
                              <input type="checkbox" id="sous-secteur-batiment" className="h-4 w-4 text-blue-600 rounded" defaultChecked data-id="element-1041" />
                              <label htmlFor="sous-secteur-batiment" className="ml-2 text-sm text-gray-700" data-id="element-1042">
                                Bâtiment
                              </label>
                            </div>
                            <div className="flex items-center" data-id="element-1043">
                              <input type="checkbox" id="sous-secteur-genie" className="h-4 w-4 text-blue-600 rounded" defaultChecked data-id="element-1044" />
                              <label htmlFor="sous-secteur-genie" className="ml-2 text-sm text-gray-700" data-id="element-1045">
                                Génie civil
                              </label>
                            </div>
                            <div className="flex items-center" data-id="element-1046">
                              <input type="checkbox" id="sous-secteur-infra" className="h-4 w-4 text-blue-600 rounded" data-id="element-1047" />
                              <label htmlFor="sous-secteur-infra" className="ml-2 text-sm text-gray-700" data-id="element-1048">
                                Infrastructures routières
                              </label>
                            </div>
                            <div className="flex items-center" data-id="element-1049">
                              <input type="checkbox" id="sous-secteur-materiaux" className="h-4 w-4 text-blue-600 rounded" data-id="element-1050" />
                              <label htmlFor="sous-secteur-materiaux" className="ml-2 text-sm text-gray-700" data-id="element-1051">
                                Matériaux de construction
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Secteur 2 avec sous-secteurs */}
                      <div className="border-b border-gray-200" data-id="element-1052">
                        <div className="flex items-center justify-between px-3 py-2 bg-gray-50 cursor-pointer" data-id="element-1053">
                          <div className="flex items-center" data-id="element-1054">
                            <input type="checkbox" id="secteur-tech" className="h-4 w-4 text-blue-600 rounded" defaultChecked data-id="element-1055" />
                            <label htmlFor="secteur-tech" className="ml-2 text-gray-700 font-medium" data-id="element-1056">
                              Technologies & Télécoms
                            </label>
                          </div>
                          <ChevronDownIcon size={16} className="text-gray-500" data-id="element-1057" />
                        </div>
                        <div className="px-3 py-2 bg-white" data-id="element-1058">
                          <div className="grid grid-cols-2 gap-2 pl-6" data-id="element-1059">
                            <div className="flex items-center" data-id="element-1060">
                              <input type="checkbox" id="sous-secteur-materiel" className="h-4 w-4 text-blue-600 rounded" defaultChecked data-id="element-1061" />
                              <label htmlFor="sous-secteur-materiel" className="ml-2 text-sm text-gray-700" data-id="element-1062">
                                Matériels et Équipements
                              </label>
                            </div>
                            <div className="flex items-center" data-id="element-1063">
                              <input type="checkbox" id="sous-secteur-logiciels" className="h-4 w-4 text-blue-600 rounded" data-id="element-1064" />
                              <label htmlFor="sous-secteur-logiciels" className="ml-2 text-sm text-gray-700" data-id="element-1065">
                                Logiciels et Solutions
                              </label>
                            </div>
                            <div className="flex items-center" data-id="element-1066">
                              <input type="checkbox" id="sous-secteur-services" className="h-4 w-4 text-blue-600 rounded" defaultChecked data-id="element-1067" />
                              <label htmlFor="sous-secteur-services" className="ml-2 text-sm text-gray-700" data-id="element-1068">
                                Services Numériques
                              </label>
                            </div>
                            <div className="flex items-center" data-id="element-1069">
                              <input type="checkbox" id="sous-secteur-telecom" className="h-4 w-4 text-blue-600 rounded" data-id="element-1070" />
                              <label htmlFor="sous-secteur-telecom" className="ml-2 text-sm text-gray-700" data-id="element-1071">
                                Infrastructures Télécoms
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Ajouter un secteur bouton */}
                      <div className="px-3 py-2 bg-gray-50 text-center" data-id="element-1072">
                        <button className="text-blue-600 text-sm font-medium flex items-center justify-center w-full" data-id="element-1073">
                          <span className="mr-1" data-id="element-1074">+</span> Ajouter un secteur
                        </button>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-1075">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1076">
                      Pays
                    </label>
                    <div className="flex flex-wrap gap-2" data-id="element-1077">
                      {['Tunisie', 'Maroc', 'Algérie', 'Sénégal'].map((country, index) => <span key={index} className="px-3 py-1.5 bg-blue-50 text-blue-800 text-sm font-medium rounded-full flex items-center" data-id="element-1078">
                            {country}
                            <button className="ml-2 text-blue-500 hover:text-blue-700" data-id="element-1079">
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" data-id="element-1080">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" data-id="element-1081" />
                              </svg>
                            </button>
                          </span>)}
                    </div>
                  </div>
                  <div data-id="element-1082">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1083">
                      Canaux de notification
                    </label>
                    <div className="space-y-2" data-id="element-1084">
                      <div className="flex items-center" data-id="element-1085">
                        <input type="checkbox" id="email" className="h-4 w-4 text-blue-600 rounded" defaultChecked data-id="element-1086" />
                        <label htmlFor="email" className="ml-2 text-gray-700" data-id="element-1087">
                          Email
                        </label>
                      </div>
                      <div className="flex items-center" data-id="element-1088">
                        <input type="checkbox" id="sms" className="h-4 w-4 text-blue-600 rounded" defaultChecked data-id="element-1089" />
                        <label htmlFor="sms" className="ml-2 text-gray-700" data-id="element-1090">
                          SMS
                        </label>
                      </div>
                      <div className="flex items-center" data-id="element-1091">
                        <input type="checkbox" id="app" className="h-4 w-4 text-blue-600 rounded" defaultChecked data-id="element-1092" />
                        <label htmlFor="app" className="ml-2 text-gray-700" data-id="element-1093">
                          Application
                        </label>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-1094">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1095">
                      Fréquence
                    </label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-1096">
                      <option data-id="element-1097">Immédiatement</option>
                      <option data-id="element-1098">Résumé quotidien</option>
                      <option data-id="element-1099">Résumé hebdomadaire</option>
                    </select>
                  </div>
                  <div className="pt-4" data-id="element-1100">
                    <Button variant="primary" fullWidth data-id="element-1101">
                      Enregistrer les préférences
                    </Button>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Testimonials */}
      <section className="py-20" data-id="element-1102">
        <div className="container mx-auto px-4" data-id="element-1103">
          <div className="text-center mb-16" data-id="element-1104">
            <span className="inline-block px-3 py-1 bg-blue-50 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-1105">
              Témoignages
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-1106">
              Ce que disent nos clients
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1107">
              Découvrez comment nos alertes intelligentes aident les entreprises
              à identifier et saisir de nouvelles opportunités d'affaires.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1108">
            {[{
            quote: "Grâce aux alertes d'ElevateIT, nous avons pu remporter trois appels d'offres majeurs que nous aurions manqués autrement. Un gain de temps et d'efficacité considérable.",
            author: 'Mehdi Benali',
            position: 'Directeur Commercial, Construct Plus',
            image: 'https://randomuser.me/api/portraits/men/32.jpg'
          }, {
            quote: "Le système d'alertes intelligentes est remarquablement précis. Nous ne recevons que des opportunités pertinentes, ce qui nous évite de perdre du temps sur des projets qui ne correspondent pas à notre expertise.",
            author: 'Sonia Mansour',
            position: 'PDG, TechSolutions Tunisie',
            image: 'https://randomuser.me/api/portraits/women/44.jpg'
          }, {
            quote: "Les notifications SMS pour les appels d'offres urgents nous ont permis de réagir rapidement à plusieurs reprises. Un service qui fait vraiment la différence dans un secteur où la réactivité est cruciale.",
            author: 'Karim Zouaoui',
            position: 'Responsable des Marchés, MédicalEquip',
            image: 'https://randomuser.me/api/portraits/men/75.jpg'
          }].map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-1109">
                <div className="mb-6" data-id="element-1110">
                  <svg className="h-8 w-8 text-yellow-400" fill="currentColor" viewBox="0 0 24 24" data-id="element-1111">
                    <path d="M9.983 3v7.391c0 5.704-3.731 9.57-8.983 10.609l-.995-2.151c2.432-.917 3.995-3.638 3.995-5.849h-4v-10h10zm14.017 0v7.391c0 5.704-3.748 9.571-9 10.609l-.996-2.151c2.433-.917 3.996-3.638 3.996-5.849h-3.983v-10h9.983z" data-id="element-1112" />
                  </svg>
                </div>
                <p className="text-gray-700 mb-6" data-id="element-1113">"{testimonial.quote}"</p>
                <div className="flex items-center" data-id="element-1114">
                  <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full mr-4" data-id="element-1115" />
                  <div data-id="element-1116">
                    <h4 className="font-bold text-gray-900" data-id="element-1117">
                      {testimonial.author}
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-1118">
                      {testimonial.position}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 bg-blue-900 text-white" data-id="element-1119">
        <div className="container mx-auto px-4" data-id="element-1120">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1121">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1122">
              Prêt à ne plus manquer d'opportunités?
            </h2>
            <p className="text-xl text-blue-100 mb-8" data-id="element-1123">
              Configurez vos alertes intelligentes dès aujourd'hui et recevez
              des notifications pour les appels d'offres qui correspondent
              parfaitement à votre activité.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-1124">
              <Button variant="primary" size="lg" className="shadow-lg shadow-yellow-500/20 bg-yellow-500 hover:bg-yellow-400 text-blue-900" data-id="element-1125">
                Commencer gratuitement
              </Button>
              <Button variant="secondary" size="lg" className="bg-white text-blue-900 hover:bg-blue-50" data-id="element-1126">
                Voir les tarifs
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="py-20" data-id="element-1127">
        <div className="container mx-auto px-4" data-id="element-1128">
          <div className="text-center mb-16" data-id="element-1129">
            <span className="inline-block px-3 py-1 bg-blue-50 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-1130">
              Questions fréquentes
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-1131">
              Tout ce que vous devez savoir
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1132">
              Nous avons rassemblé les questions les plus fréquentes concernant
              notre système d'alertes intelligentes.
            </p>
          </div>
          <div className="max-w-3xl mx-auto" data-id="element-1133">
            <div className="space-y-6" data-id="element-1134">
              {[{
              question: "Comment fonctionne le système d'alertes intelligentes?",
              answer: "Notre système analyse en continu les nouveaux appels d'offres publiés sur différentes plateformes. En utilisant l'intelligence artificielle, il compare ces opportunités avec votre profil d'entreprise et vos préférences pour vous proposer uniquement les plus pertinentes."
            }, {
              question: "Puis-je personnaliser mes critères d'alerte?",
              answer: "Absolument. Vous pouvez définir vos critères selon plusieurs paramètres: secteurs d'activité, sous-secteurs spécifiques, zones géographiques, montants des marchés, types de procédures, mots-clés spécifiques, etc. Vous pouvez également ajuster ces critères à tout moment."
            }, {
              question: "Combien d'alertes vais-je recevoir?",
              answer: "Cela dépend entièrement de vos critères et de la disponibilité des appels d'offres correspondants. Notre objectif est de vous fournir uniquement des alertes de qualité. Vous pouvez également configurer une limite quotidienne si vous le souhaitez."
            }, {
              question: 'Les alertes sont-elles disponibles pour tous les pays?',
              answer: "Notre service couvre actuellement tous les pays d'Afrique du Nord et de l'Ouest. Nous travaillons continuellement à l'extension de notre couverture géographique. Consultez notre page de couverture pour voir la liste complète des pays disponibles."
            }, {
              question: 'Puis-je désactiver temporairement les alertes?',
              answer: "Oui, vous pouvez facilement mettre en pause vos alertes à tout moment depuis votre tableau de bord. Vous pouvez également configurer des périodes d'absence automatiques."
            }].map((faq, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-1135">
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1136">
                    {faq.question}
                  </h3>
                  <p className="text-gray-600" data-id="element-1137">{faq.answer}</p>
                </div>)}
            </div>
            <div className="mt-10 text-center" data-id="element-1138">
              <p className="text-gray-600 mb-4" data-id="element-1139">
                Vous avez d'autres questions?
              </p>
              <Button variant="outline" size="lg" className="border-2 border-blue-900" data-id="element-1140">
                Contactez-nous
              </Button>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-1141" />
      <FloatingCTA data-id="element-1142" />
    </div>;
}